import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4c9633ba&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=4c9633ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9633ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c9633ba')) {
      api.createRecord('4c9633ba', component.options)
    } else {
      api.reload('4c9633ba', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=4c9633ba&scoped=true", function () {
      api.rerender('4c9633ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exercise/taskBase/list.vue"
export default component.exports